export enum SubscriptionType {
  INDIVIDUAL = 'individual',
  STRUCTURE = 'structure',
}

export enum StatutType {
  GROUPE = 'groupe',
  INDIVIDUEL = 'individuel',
}
